const zh_tw = {
  placeholderText: "請輸入",
  closeContentText: "確定結束當前對話？",
  cancelText: "取消",
  okText: "確定",
  loadingAnswerQuestions: "正在回答上一個問題，請稍後提交",
  networkAnomalyText: "網絡异常，請稍後重試",
  errorText: "服務器錯誤",
  messageTooShort: "至少需要輸入2個文字",
  messageTooLong: "不能超過200個文字",
  systemErrorText: "系統錯誤，請稍後重試",
  fileSizeExceeded: "單個檔案不能超過{maxSize}MB",
  abnormalDisconnectionText: "异常斷開，正在為您重連...",
  evaluationText: "您的評估讓我們做的更好！",
  emailLabel: "郵箱",
  emailPlaceholder: "請輸入郵箱",
  emailErrorText: "郵箱格式錯誤",
  productLabel: "產品",
  productPlaceholder: "請選擇產品",
  problemLabel: "問題描述",
  problemPlaceholder: "問題描述",
  submitText: "提交",
  submitField: "抱歉，未提交成功，請稍後重試",
  thankText:
    "感謝您的配合，我們會盡快聯繫您！請關注郵箱或者{link}留意消息回覆！",
  clickHere: "點擊此處",
  thankEvaluation: "感謝您的評價！",
  codeLabel: "驗證碼",
  codePlaceholder: "請輸入驗證碼",
  submittedSuccessfully: "提交成功",
  supportContact: "支援聯絡",
  stillCancel: "依然取消",
  useDiscount: "使用折扣",
  pauseDuration: "暫停時長",
  uploadAttachment: "上傳附件",
};
export default zh_tw;
